/* OUTFAIR infinite scroll (hybrid).
 *
 * How it works:
 * - On collection pages, when the shopper scrolls near the bottom, the next
 *   page of products is fetched and appended to the same grid (auto-load).
 *   The trigger is a scroll/resize check on a 1px sentinel element placed
 *   just below the grid (an IntersectionObserver version was tested first
 *   and never fired in the preview browser, so the scroll check is used).
 * - After AUTO_LOADS automatic batches, auto-loading stops and a
 *   "Load more products" button takes over, so the footer stays reachable
 *   and shoppers stay in control. When the last page is loaded, the button
 *   and the numbered pagination are removed entirely.
 * - Numbered pagination links stay in the server-rendered HTML, so search
 *   engines can still crawl ?page=2, ?page=3, ... and shoppers without
 *   JavaScript keep the old numbered pages (progressive enhancement).
 * - Filter/sort changes re-render the grid (facets.js). A MutationObserver
 *   detects the new pagination block and resets the loader state.
 * - Appended cards have Dawn's scroll-reveal classes stripped, otherwise
 *   they would stay invisible (the reveal observer only runs on page load).
 */
(function () {
  var AUTO_LOADS = 3;
  var grid = document.getElementById('product-grid');
  var container = document.getElementById('ProductGridContainer');
  if (!grid || !container) return;


  var autoLoads = 0;
  var loading = false;
  var sentinel = null;
  var scrollBound = false;
  var loadMoreBtn = null;
  var statusEl = null;
  var currentNav = getNav();

  function getNav() {
    return container.querySelector('nav.pagination');
  }

  function getNextUrl(nav) {
    if (!nav) return null;
    var next = nav.querySelector('a[aria-label="Next page"]');
    if (next) return next.getAttribute('href');
    var current = nav.querySelector('.pagination__item--current');
    if (current) {
      var num = parseInt(current.textContent.trim(), 10);
      if (!isNaN(num)) {
        var link = nav.querySelector('a[aria-label="Page ' + (num + 1) + '"]');
        if (link) return link.getAttribute('href');
      }
    }
    return null;
  }

  function setStatus(text) {
    if (!statusEl) {
      statusEl = document.createElement('p');
      statusEl.className = 'infinite-scroll-status center';
      statusEl.setAttribute('aria-live', 'polite');
      statusEl.style.cssText = 'margin:1.5rem 0;';
      grid.parentNode.insertBefore(statusEl, grid.nextSibling);
    }
    statusEl.textContent = text;
  }

  function removeLoadMoreButton() {
    if (loadMoreBtn) {
      loadMoreBtn.remove();
      loadMoreBtn = null;
    }
  }

  function showLoadMoreButton() {
    if (loadMoreBtn && loadMoreBtn.isConnected) return;
    if (loadMoreBtn && !loadMoreBtn.isConnected) loadMoreBtn = null;
    if (sentinel) {
      sentinel.remove();
      sentinel = null;
    }
    loadMoreBtn = document.createElement('button');
    loadMoreBtn.type = 'button';
    loadMoreBtn.id = 'infinite-scroll-load-more';
    loadMoreBtn.className = 'button button--primary';
    loadMoreBtn.textContent = 'Load more products';
    loadMoreBtn.style.cssText = 'display:block;margin:2rem auto;';
    loadMoreBtn.addEventListener('click', function () {
      loadNext(true);
    });
    var nav = getNav();
    if (nav) {
      nav.setAttribute('hidden', '');
      // The pagination nav lives inside a .pagination-wrapper div, NOT
      // directly under the grid's parent, so insert relative to the nav's
      // own parent (inserting against the grid's parent throws).
      nav.parentNode.insertBefore(loadMoreBtn, nav);
    } else {
      container.appendChild(loadMoreBtn);
    }
  }

  function afterLoad(manual) {
    var nav = getNav();
    if (!getNextUrl(nav)) {
      // Last page reached: clear the controls so the footer is reachable.
      removeLoadMoreButton();
      if (nav) nav.remove();
      if (sentinel) {
        sentinel.remove();
        sentinel = null;
      }
      currentNav = null;
      return;
    }
    if (!manual) {
      autoLoads += 1;
      if (autoLoads >= AUTO_LOADS) showLoadMoreButton();
    }
  }

  function loadNext(manual) {
    var nav = getNav();
    var url = getNextUrl(nav);
    if (!url || loading) return;
    loading = true;
    setStatus('Loading more products…');
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var newNav = doc.querySelector('nav.pagination');
        if (!newGrid) throw new Error('no product grid in response');
        var items = newGrid.querySelectorAll(':scope > li');
        items.forEach(function (li) {
          // Dawn's scroll-reveal would leave appended cards invisible.
          li.classList.remove('scroll-trigger', 'animate--slide-in');
          li.removeAttribute('style');
          grid.appendChild(li);
        });
        if (nav && newNav) {
          nav.replaceWith(newNav);
        } else if (nav && !newNav) {
          nav.remove();
        }
        currentNav = getNav();
        loading = false;
        setStatus('');
        // While the manual button is the control, keep the numbered
        // pagination hidden: the fresh nav from the server is visible
        // by default and would otherwise reappear next to the button.
        if (loadMoreBtn && currentNav) currentNav.setAttribute('hidden', '');
        afterLoad(manual);
      })
      .catch(function (err) {
        loading = false;
        setStatus('');
        // Never leave a dead end: fall back to the manual button, and
        // un-hide the numbered pagination so shoppers can still navigate.
        var nav2 = getNav();
        if (nav2) nav2.removeAttribute('hidden');
        showLoadMoreButton();
      });
  }

  // Scroll trigger: when the sentinel comes within 600px of the bottom of
  // the viewport, load the next page (up to AUTO_LOADS times, then the
  // manual button takes over).
  function checkSentinel() {
    if (!sentinel || loading || autoLoads >= AUTO_LOADS) return;
    if (sentinel.getBoundingClientRect().top < window.innerHeight + 600) loadNext(false);
  }

  function ensureSentinel() {
    if (sentinel || !getNextUrl(getNav())) return;
    sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:1px;';
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);
    if (!scrollBound) {
      scrollBound = true;
      window.addEventListener('scroll', checkSentinel, { passive: true });
      window.addEventListener('resize', checkSentinel);
    }
    checkSentinel();
  }

  // Filter/sort changes re-render the grid: reset the loader when the
  // pagination block is replaced by a new one.
  var resetObserver = new MutationObserver(function () {
    var nav = getNav();
    if (nav !== currentNav) {
      autoLoads = 0;
      loading = false;
      removeLoadMoreButton();
      var hiddenNav = container.querySelector('nav.pagination[hidden]');
      if (hiddenNav) hiddenNav.removeAttribute('hidden');
      if (sentinel) {
        sentinel.remove();
        sentinel = null;
      }
      // facets.js replaced the whole grid markup: the old grid and status
      // line are now detached. Re-acquire the LIVE grid
      // before re-arming, otherwise the new sentinel (and any appended
      // products) would land in the detached old grid and nothing would
      // visibly load.
      grid = container.querySelector('#product-grid');
      if (!grid) return;
      statusEl = null;
      currentNav = nav;
      ensureSentinel();
    }
  });
  resetObserver.observe(container, { childList: true, subtree: true });

  ensureSentinel();
})();
